<template>
    <div>
      <div class="kind-box">
        <div class="kind-item">
          <img src="/static/images/HomeTH/flowe.png">
          <p>多元化销售解决方案</p>
        </div>
        <div class="kind-item">
          <img src="/static/images/HomeTH/safe.png">
          <p>品质可靠，值得信赖</p>
        </div>
        <div class="kind-item">
          <img src="/static/images/HomeTH/kind.png">
          <p>产品丰富，购物多样化</p>
        </div>
        <div class="kind-item">
          <img src="/static/images/HomeTH/heart.png">
          <p>定制化服务，无忧体验</p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {},
        computed: {},
        components: {}
    }
</script>

<style scoped>
.kind-box{
  display: flex;
  width: 1300px;
  margin: 0px auto;
}
  .kind-item{
    text-align: center;
    flex: 1;
    margin-top: 150px;
  }
  .kind-item img{
    width: 64px;
  }
  .kind-item p{
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-top: 30px;
  }
@media only screen and (max-width: 1366px) {
  .kind-box{
    width: 980px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HomeSupport/HomeSupport.vue